/* eslint-disable */
// 屏幕适配
(function (doc, win, undefined) {
  var docEl = doc.documentElement
  var resizeEvt = 'orientationchange' in win ? 'orientationchange' : 'resize'
  var recalc = function () {
    var clientWidth = docEl.clientWidth
    if (clientWidth === undefined) return
    docEl.style.fontSize = 100 * (clientWidth / 750) + 'px'
  }
  if (doc.addEventListener === undefined) return
  win.addEventListener(resizeEvt, recalc, false)
  doc.addEventListener('DOMContentLoaded', recalc, false)
})(document, window);



// WEBPACK FOOTER //
// ./src/utils/resize.js